import { render } from "./Boolean.vue?vue&type=template&id=ec847760"
import script from "./Boolean.vue?vue&type=script&setup=true&lang=js"
export * from "./Boolean.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Filters/Types/Boolean.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec847760"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec847760', __exports__)) {
    api.reload('ec847760', __exports__)
  }
  
  module.hot.accept("./Boolean.vue?vue&type=template&id=ec847760", () => {
    api.rerender('ec847760', render)
  })

}


export default __exports__